import { render } from "./CrudLicenca.vue?vue&type=template&id=4ac8e208&scoped=true"
import script from "./CrudLicenca.vue?vue&type=script&lang=ts"
export * from "./CrudLicenca.vue?vue&type=script&lang=ts"

import "./CrudLicenca.vue?vue&type=style&index=0&id=4ac8e208&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4ac8e208"

export default script